import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en.js"; 
import zhLocale from "element-ui/lib/locale/lang/zh-CN.js"; 
import zh from './locales/zh'
import en from './locales/en'
// 注册i18n
Vue.use(VueI18n);
 
export const i18n = new VueI18n({
  locale: localStorage.getItem("change-language") || "zh", 
  messages: {
    zh: { ...zh, ...zhLocale }, 
    EN: { ...en, ...enLocale }, 
  },
});
 
// 配置 Element UI 使用 vue-i18n
const ElementUI = require("element-ui");
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
 
export default i18n;